type ExperimentTag = {
  num: number;
  id: string;
  variant: string;
};

export type Experiments = ExperimentTag[];

export const reorderWritePageExperimentTestGroup: ExperimentTag = {
  num: 1,
  id: 'reorder_write_page',
  variant: '1',
};

export const reorderWritePageExperimentControlGroup: ExperimentTag = {
  num: 1,
  id: 'reorder_write_page',
  variant: '0',
};
